import { Dialog, DialogContent } from '@/components/ui'
import { AddAccountForm, type AddAccountFormProps } from './AddAccountForm'

interface AddAccountDialogProps extends AddAccountFormProps {
  open: boolean
}

export const AddAccountDialog = ({
  open,
  filing,
  onAdd,
  onClose,
}: AddAccountDialogProps) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <DialogContent data-add-account-dialog>
      <AddAccountForm filing={filing} onAdd={onAdd} onClose={onClose} />
    </DialogContent>
  </Dialog>
)
